import { NotificationOutlined } from "@ant-design/icons";
import { Button, Modal, Typography } from "antd";
import moment from "moment";
import { DATA_FORMATO } from "../../utils";
import { ConteudoFormatado } from "./ConteudoFormatado";
import "./mensagemGlobal.css";

const { Title, Text } = Typography;

export const ModalMensagem = ({
  visivel,
  mensagem,
  confirmando,
  onMarcarLida,
  onFechar,
}) => {
  return (
    <Modal
      visible={visivel}
      centered
      width="80%"
      style={{ maxWidth: 720 }}
      wrapClassName="modal-mensagem-sistema"
      title={
        <span className="modal-mensagem-titulo">
          <NotificationOutlined />
          Mensagem do sistema
        </span>
      }
      maskClosable={false}
      keyboard
      onCancel={onFechar}
      footer={[
        <Button key="fechar" onClick={onFechar}>
          fechar
        </Button>,
        <Button
          key="lida"
          type="primary"
          loading={confirmando}
          onClick={onMarcarLida}
        >
          marcar como lida
        </Button>,
      ]}
    >
      {mensagem && (
        <>
          <Title level={4} className="mensagem-titulo-destaque">
            {mensagem.titulo}
          </Title>
          {mensagem.dataCadastro && (
            <Text type="secondary">
              {moment(mensagem.dataCadastro).format(`${DATA_FORMATO} HH:mm`)}
            </Text>
          )}
          <div style={{ marginTop: 12 }}>
            <ConteudoFormatado
              conteudo={mensagem.conteudo}
              className="conteudo-mensagem-scroll conteudo-mensagem-scroll--modal"
            />
          </div>
        </>
      )}
    </Modal>
  );
};

